import { Link } from "react-router-dom";
import { Phone, MapPin, Check, ArrowRight, Nfc } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES, WHY_CHOOSE_US } from "../../data/site";

const TomTrustRow = () => (
    <div
        data-testid="hero-tom-trust-row"
        className="flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-3 py-2.5 mb-5 max-w-md shadow-sm"
    >
        <img
            src={IMAGES.tom}
            alt="Tom — your local Adelaide computer technician"
            data-testid="hero-image"
            className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover ring-2 ring-orange-100 shrink-0"
            loading="eager"
        />
        <div className="min-w-0">
            <p className="font-heading font-semibold text-[#0F2E52] text-base leading-snug">
                Hi, I'm Tom — your local Adelaide technician.
            </p>
            <p className="text-sm text-slate-500 mt-0.5">
                Born and raised in Adelaide · Call me directly
            </p>
        </div>
    </div>
);

export const Hero = () => (
    <section id="top" data-testid="hero-section" className="bg-slate-50 border-b border-slate-100 overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 md:py-14">
            <p className="inline-flex items-center gap-1.5 bg-orange-50 border border-orange-200 text-[#ea580c] text-xs font-semibold uppercase tracking-wider rounded-full px-3 py-1.5 mb-4">
                <MapPin className="w-3.5 h-3.5" /> Semaphore SA 5019 · We Come To You
            </p>
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#0F2E52] leading-tight mb-3 max-w-3xl">
                Computer Repairs <span className="text-[#ea580c]">Semaphore</span> &amp; Western Suburbs
            </h1>
            <p className="font-heading text-lg md:text-xl font-semibold text-blue-600 mb-4">
                Onsite computer help at your home or business
            </p>
            <TomTrustRow />
            <p data-testid="hero-payment-line" className="flex items-center gap-2 text-sm font-medium text-[#0F2E52] mb-5">
                <Nfc className="w-5 h-5 text-[#ea580c] shrink-0" />
                <span>
                    <span className="font-semibold">Easy Payments Onsite</span> — EFTPOS or cash accepted once the
                    job is completed.
                </span>
            </p>
            <Link
                to="/pricing"
                data-testid="hero-view-pricing-mobile"
                className="md:hidden inline-flex items-center justify-center gap-1.5 w-full bg-white border-2 border-blue-600 text-blue-600 font-semibold rounded-full px-6 py-2.5 mb-5"
            >
                View Pricing <ArrowRight className="w-4 h-4" />
            </Link>
            <div className="hidden md:flex flex-wrap items-center gap-3 mb-6">
                <a
                    href={PHONE_TEL}
                    data-testid="hero-call-now-button"
                    className="inline-flex items-center gap-2 bg-[#ea580c] hover:bg-[#c2410c] text-white font-semibold rounded-full px-8 py-3 transition-colors shadow-lg shadow-orange-500/20"
                >
                    <Phone className="w-4 h-4" />
                    Call {PHONE_DISPLAY}
                </a>
                <a
                    href="#contact"
                    data-testid="hero-book-callout-button"
                    className="inline-flex items-center bg-white border-2 border-[#0F2E52] text-[#0F2E52] hover:bg-slate-50 font-semibold rounded-full px-8 py-3 transition-colors"
                >
                    Book a Callout
                </a>
                <Link
                    to="/pricing"
                    data-testid="hero-view-pricing-link"
                    className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:underline px-2"
                >
                    View Pricing <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
            <div data-testid="hero-why-choose-us" className="border-t border-slate-200 pt-5">
                <h2 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#0F2E52] mb-3">
                    Why Choose Us?
                </h2>
                <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                    {WHY_CHOOSE_US.map((point, index) => (
                        <li
                            key={point}
                            data-testid={`hero-trust-point-${index}`}
                            className="flex items-start gap-2.5 text-base font-medium text-slate-700"
                        >
                            <span className="w-6 h-6 rounded-full bg-white border border-orange-200 flex items-center justify-center shrink-0 mt-0.5">
                                <Check className="w-3.5 h-3.5 text-[#ea580c]" />
                            </span>
                            {point}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);
